define.alias("shared/utils/number-helpers/floor-to-significant-digits", "media/utils/number-helpers/floor-to-significant-digits");